import styled from "styled-components"


export const ContainerCenter = styled.div `
    max-width: 780px;
    width: 100%;
    padding: 20px;
    margin: 0 auto;
`

export const ContainerSplit = styled.div `
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`